import { StoryblokVue } from '@storyblok/vue'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(StoryblokVue)
})
